const Pagination = ({
  currentPage,
  totalPages,
  pageSize,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
}) => {
  const safePage = Math.min(Math.max(currentPage, 1), totalPages || 1);

  return (
    <div className="pagination">
      <div className="pagination-size">
        <label className="pagination-label" htmlFor="page-size-select">
          Na stronie
        </label>
        <select
          id="page-size-select"
          className="pagination-select"
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
        >
          {pageSizeOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
      <div className="pagination-controls">
        <button
          type="button"
          className="secondary"
          onClick={() => onPageChange(Math.max(1, safePage - 1))}
          disabled={safePage <= 1}
        >
          Poprzednia
        </button>
        <span className="pagination-info">
          Strona {safePage} z {totalPages || 1}
        </span>
        <button
          type="button"
          className="secondary"
          onClick={() => onPageChange(Math.min(totalPages || 1, safePage + 1))}
          disabled={safePage >= (totalPages || 1)}
        >
          Nastepna
        </button>
      </div>
    </div>
  );
};

export default Pagination;


